import { gql, useQuery } from '@apollo/client';
import useAppSelector from '../app/redux/useAppSelector';
import type { AllowPublicContentSettingsQuery } from '../graphql/generated/graphqlTypes';
import { AllowPublicContentBy } from '../graphql/generated/graphqlTypes';

const ALLOW_PUBLIC_CONTENT_SETTINGS_QUERY = gql`
  query allowPublicContentSettings {
    session: currentSession {
      organization {
        id
        settings {
          allowPublicContentBy
        }
      }
    }
  }
`;

const useAllowPublicContentBy = () => {
  const { data } = useQuery<AllowPublicContentSettingsQuery>(
    ALLOW_PUBLIC_CONTENT_SETTINGS_QUERY,
  );

  return data?.session?.organization?.settings?.allowPublicContentBy || null;
};

export const usePublicContentPermissions = () => {
  const user = useAppSelector((state) => state.session.user);
  const allowPublicContentBy = useAllowPublicContentBy();

  const isAdmin = user.type === 'ADMIN';

  return {
    isPermittedToPublicizePost:
      isAdmin ||
      allowPublicContentBy === AllowPublicContentBy.All ||
      allowPublicContentBy === AllowPublicContentBy.AdminTopicsUserPosts,
    isPermittedToSetTopicToPublic:
      isAdmin || allowPublicContentBy === AllowPublicContentBy.All,
    isPermittedToCreatePublicSubtopic:
      isAdmin || allowPublicContentBy === AllowPublicContentBy.All,
  };
};

export default useAllowPublicContentBy;
